import './Therapy.css';
export default function Therapy(){
    return(
        <div id='therapy' className="the">
        <h2 className='tex'>Терапия в нашей клинике</h2>
            <div>
                <p className='tex'>Терапия - область гуманной и ветеринарной медицины, занимающаяся непосредственно лечением патологий, облегчением состояния больного и устранением симптомов заболеваний.</p>
                <p>Терапевтическое отделение клиники Айболит занимается диагностикой и лечением следующих болезней:</p>              
                <p>- органов пищеварения;</p>
                <p>- органов сердечно-сосудистой системы;</p>
                <p>- органов дыхательной системы;</p>
                <p>- нервной системы;</p>
                <p>- органов мочевыделительной системы;</p>
                <p>- эндокринной системы;</p>
                <p>- нарушения обмена веществ;</p>
                <p>- кожи и ее производных;</p>
                <p>- органов чувств;</p>
                <p>- репродуктивной области;</p>
                <p>- инфекционной и инвазионной природы;</p>
                <p>- токсикологической природы.</p>  
            </div>
            

    </div>
    )
}